import React from 'react';
import { FaGithub, FaFacebookF, FaLinkedinIn, FaBlog } from 'react-icons/fa';
import { SiX } from 'react-icons/si';

const HeaderSocials = () => {
  return (
    <div className='home__socials'>
      {/* GitHub */}
      <a
        href='https://github.com/Khandaker-Atik'
        className='home__social-link'
        target='_blank'
        rel='noreferrer'
      >
        <FaGithub />
      </a>

      {/* LinkedIn */}
      <a
        href='https://linkedin.com/in/atikur-rahman007'
        className='home__social-link'
        target='_blank'
        rel='noreferrer'
      >
        <FaLinkedinIn />
      </a>

      {/* Facebook */}
      <a
        href='https://www.facebook.com/therealatik'
        className='home__social-link'
        target='_blank'
        rel='noreferrer'
      >
        <FaFacebookF />
      </a>

      {/* X (Twitter) */}
      <a
        href='https://x.com/Atik_Khandaker'
        className='home__social-link'
        target='_blank'
        rel='noreferrer'
      >
        <SiX />
      </a>

      {/* Blogspot */}
      <a
        href='https://khandaker-atik.blogspot.com'
        className='home__social-link'
        target='_blank'
        rel='noreferrer'
      >
        <FaBlog />
      </a>
    </div>
  );
};

export default HeaderSocials;
